export default __webpack_public_path__ + "static/media/beOPX.f61ea241.png";